import { ComponentType, ReactNode, Suspense } from 'react';
import LoadingSpinner from '@shared/components/molecules/Loader';

// lazy 컴포넌트를 Suspense 로 감싸는 HOC 컴포넌트
export const withSuspense = (
    Component: ComponentType,
    fallback: ReactNode = <LoadingSpinner />,
): ReactNode => {
    return (
        <Suspense fallback={fallback}>
            <Component />
        </Suspense>
    );
};
